// Public navigation API.
//
// Prefer `useAppModule().navigation` or `getNavigationForModule(module)` over
// the legacy `baseNavigation*` exports. The aliases below are kept so existing
// imports keep working until consumers migrate.

import { APP_MODULES } from 'constants/module.constant';
import { getNavigationForModule } from './navigation';

export { getNavigationForModule };

export const baseNavigation = getNavigationForModule(APP_MODULES.INDUSTRIAL);
export const baseNavigationMonitoring = getNavigationForModule(
  APP_MODULES.MONITORING
);
export const baseNavigationManager = getNavigationForModule(
  APP_MODULES.MANAGER
);
